module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"spendLimitsTable.noLimits":"There are no spend limits yet.","spendLimitsTable.loadingLimits":"Loading spending limits","spendLimitsTable.progress":"Progress","spendLimitsTable.projections":"Forecast","spendLimitsTable.actual":"Current Spend","spendLimitsTable.limit":"Spend Limit Amount"}}')
  delete Component.options._Ctor
}
